import { render, staticRenderFns } from "./IcoThumbUp.vue?vue&type=template&id=90507756"
import script from "./IcoThumbUp.vue?vue&type=script&lang=js"
export * from "./IcoThumbUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports